import { faArrowRight } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Link from "next-intl/link"
import MobileNavLink from "./mobile-nav-link";
import {StrapiMenu} from "@/app/types/strapi.types";

export default  function MobileNavigation({menu} : {menu: StrapiMenu}) {

    return (
        <div className="px-5">
            {menu.items.data.map((topLevelMenuItem, index: number) => (
                <>
                    {topLevelMenuItem.attributes.children.data.length > 0 ? (
                        <MobileNavLink label={topLevelMenuItem.attributes.title} >
                            <ul className="px-5">
                                {topLevelMenuItem.attributes.children.data.map((childrenMenuItem, index: number) => (
                                    <li key={index} className={"cursor-pointer border-b"}>
                                        <Link className={`flex items-center p-5 text-lg`} href={childrenMenuItem.attributes.url} title={childrenMenuItem.attributes.title}>
                                            {childrenMenuItem.attributes.title}
                                            <FontAwesomeIcon
                                                    icon={faArrowRight}
                                                    className={"ml-auto"}
                                                />
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </MobileNavLink>
                    ) : (

                            <li className={"cursor-pointer border-b"}>
                                <Link className={`flex items-center p-5 text-lg`} href={topLevelMenuItem.attributes.url} title={topLevelMenuItem.attributes.title}>
                                    {topLevelMenuItem.attributes.title}
                                    <FontAwesomeIcon
                                            icon={faArrowRight}
                                            className={"ml-auto"}
                                        />
                                </Link>
                            </li>

                    )}
                </>

            ))}
        </div>
    )
}
